import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FormErrorsComponent } from '../../form-errors/form-errors.component';

@Component({
  selector: 'app-input-textarea',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsComponent],
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
})
export class InputTextareaComponent {
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
}
